<template>
  <div>
      
  </div>
</template>

<script>
import mixins from "../../../../Mixins.js";

export default ({
  mixins: [mixins],
})
</script>
